import React from "react";
import {Col} from 'react-bootstrap';
import {BrowserRouter as Router} from "react-router-dom";
import HeaderContent from "../components/header/HeaderContent";
import HeaderActions from "../components/header/HeaderActions";
import FooterGuest from "../components/footer/FooterGuest";
import Content from "../router/content/Content";
import Actions from "../router/action/Actions";

export default function Guest() {
  return (
    <Router>
      <Col xs={6} className="content-side">
        <HeaderContent/>
        <Content/>
        <FooterGuest/>
      </Col>
      <Col xs={6} className="actions-side" id="actions-side">
        <HeaderActions/>
        <Actions/>
      </Col>
    </Router>
  );
}
